/**
 * @desc 待绑定信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDbdRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/dbdTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
